'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // The value for simple static (not editable) text fields.


function PreviewTextStatic(_ref) {
  var value = _ref.value;
  return _react2.default.createElement('span', {
    className: 'editable-fixed-value'
  }, value);
}

PreviewTextStatic.propTypes = {
  value: _propTypes2.default.string.isRequired
};
exports.default = PreviewTextStatic;
module.exports = exports['default'];